export default {
    common: {
        cancel: "キャンセル",
        save: "保存",
        close: "閉じる",
        dismiss: "閉じる",
        loading: "読み込み中...",
        notSet: "未設定",
        unknown: "不明",
        edit: "編集",
        delete: "削除",
        confirm: "確認",
        back: "戻る",
        next: "次へ",
        yes: "はい",
        no: "いいえ",
        ok: "OK",
        or: "または",
        and: "および",
        name: "名前",
        cost: "コスト",
        access: "アクセス",
        titles: "タイトル数",
        scenario: "シナリオ",
        search: "検索",
        update: "更新",
        download: "ダウンロード",
        submit: "送信",
        required: "この項目は必須です。",
        invalidEmail: "このメールアドレスは無効です。",
        personalEmail: "個人用メールアドレスのようです。",
        somethingWentWrong: "エラーが発生しました",
        copy: "コピー",
        create: "作成",
        rename: "名前を変更",
        open: "開く",
        send: "送信",
        new: "新規",
        info: "情報",
        remove: "削除",
        title: "タイトル",
        of: "/",
        clickToLearnMore: "詳細はこちらをクリック",
    },

    nav: {
        loadingInstitution: "機関を読み込み中...",
        currentInstitution: "現在の機関:",
        currentConsortium: "現在のコンソーシアム:",
        otherOrganizations: "他の組織 ({count})",
        otherInstitutions: "他の機関 ({count})",
        consortium: "コンソーシアム",
        institution: "機関",
        loadingPackage: "パッケージを読み込み中...",
        currentPackage: "現在のパッケージ:",
        otherPackages: "他のパッケージ ({count})",
        currentScenario: "現在のシナリオ:",
        otherScenarios: "他のシナリオ ({count})",
        loadingScenario: "シナリオを読み込み中...",
        consortialFeeder: "コンソーシアムフィーダー",
        about: "概要",
        learn: "情報",
        docs: "ドキュメント",
        webinars: "ウェビナー",
        documentation: "ドキュメント",
        sendFeedback: "フィードバックを送信",
        signedInAs: "ログイン中：",
        adminDashboard: "管理ダッシュボード",
        yourAccount: "アカウント設定",
        help: "ヘルプ",
        logIn: "ログイン",
        logOut: "ログアウト",
        support: "サポート",
    },

    footer: {
        team: "チーム",
        press: "プレス",
        contact: "お問い合わせ",
        twitter: "Twitter",
        sourceCode: "ソースコード",
        watchVideo: "動画を見る",
        caseStudies: "導入事例",
        purchase: "購入",
        logIn: "ログイン",
        termsOfUse: "利用規約",
        privacyPolicy: "プライバシーポリシー",
        madeWith: "Unsubは❤︎を込めて",
        withSupport: "の支援を受けて開発されています",
    },

    currency: {
        selectedCurrency: "通貨の選択",
        currencyUsedEverywhere: "選択された通貨はUnsub全体で使用されます。",
        usDollars: "米ドル (USD)",
        ukPounds: "英ポンド (GBP)",
        japaneseYen: "日本円 (JPY)",
        changeCurrency: "通貨を変更",
        selectCurrency: "通貨を選択",
        willSetCurrency: "通貨を{currency}に設定します。",
        confirmChangeCurrency: "通貨を{currency}に変更してもよろしいですか？",
        noConversion: "通貨の変更は自動的な換算を行いません。",
        updateCostsNote: "変更する場合は、パッケージのビッグディールコストとシナリオのILL処理コストパラメータを{currency}建ての値に更新してください。",
        replaceCustomPricelist: "また、カスタム価格リストの差し替えも必要です。",
        importantLabel: "重要事項：",
        importantNote: "通貨の変更は自動的な換算を行いません。通貨を変更する場合は、既に入力済みのコストを新しい通貨建ての値に更新してください。具体的には、パッケージのビッグディールコストとシナリオのILL処理コストパラメータを編集する必要があります。",
        changeTo: "{currency}に変更",
        noteLabel: "注意：",
        jpyNote: "JPYを選択した場合、JPYの価格のない外貨建てのジャーナルは、お客様でJPYに転換し、タイトル毎のISSNと価格を入れる必要があります。",
        currencyChanged: "通貨を{currency}に変更しました",
    },

    bigDeal: {
        annualCost: "ビッグディール年間コスト",
        annualCostDescription: "この出版社からのビッグディールの年間コストを入力してください。ビッグディールがない場合は、この出版社のジャーナルに対する年間総支出額を入力してください。",
        annualCostLabel: "年間コスト",
        annualCostIncrease: "ビッグディール年間コスト増加率 (%)",
        annualCostIncreaseDescription: "ビッグディールのコスト年間増加率を入力してください。上記と同様に、ビッグディールがない場合は、この出版社のタイトルへの総支出の増加率を見積もってください。",
        annualIncrease: "年間増加率",
        fiveYearAnnualCost: "ビッグディール5年間推定年間コスト",
        fiveYearAnnualCostDescription: "これは、ビッグディールを更新した場合の今後5年間の推定年間パッケージコストです。基本年間コストから自動計算されます：年間コスト増加率による5年間の値上げを計算し、年間平均を算出します。この数値は、さまざまな解約シナリオでの年間節約コストの算出に使用されます。",
        fiveYearLabel: "5年間推定年間コスト",
        editBigDealCost: "ビッグディールコストを編集",
        editBigDealCostIncrease: "ビッグディールコスト増加率を編集",
        annualCostInput: "年間コスト ({currency})",
        annualIncreaseInput: "年間増加率 (%)",
        editSuccessful: "編集が完了しました。",
    },

    scenarioView: {
        recalculating: "シナリオを再計算中...",
        recalculatingDescription: "このコンソーシアムシナリオは予測の再計算中のためロックされています。最大1時間かかる場合があります。",
        emailNotification: "更新が完了したら{email}にメールをお送りします（迷惑メールフォルダもご確認ください）。",
        annualCost: "年間コスト",
        projectedAnnualCost: "予測年間コスト",
        projectedAccess: "予測アクセス",
        costExplanation: "今後5年間で、このシナリオでは{cost}を支出します。これはビッグディールを維持した場合の{percent}に相当します。",
        accessExplanation: "今後5年間で、図書館利用者はリクエストの{percent}に容易にアクセスできます（PTA、オープンアクセス、個別購読、またはILL経由）。",
        fiveYearForecast: "5年間予測",
        usageFulfillment: "利用充足率",
        selectJournals: "ジャーナルを選択",
        newScenario: "新規シナリオ",
        consortialProposal: "これはコンソーシアム提案シナリオです。パラメータとコアとなるタイトル別購読はコンソーシアムスタッフにより設定されています。この提案シナリオに対するフィードバックを提供してください。",
        displayJournalsAs: "ジャーナルの表示形式:",
        journalSubscribed: "ジャーナルを購読しました",
        journalUnsubscribed: "ジャーナルの購読を解除しました",
        journalsSubscribed: "ジャーナルを購読しました",
        journalsUnsubscribed: "ジャーナルの購読を解除しました",
        selected: "選択済み",
        subscribeAll: "選択した{count}件のジャーナルをすべて購読します。",
        unsubscribeAll: "選択した{count}件のジャーナルの購読をすべて解除します。",
    },

    params: {
        showParameterDetails: "パラメータの詳細を表示",
        costs: "コスト",
        ill: "ILL",
        fulfillmentSources: "充足ソース",
        citationAuthorship: "引用と著者",
        titleByTitleGrowth: "個別購読コスト増加率",
        titleByTitleGrowthDescr: "個別購読価格の年間増加率（文献では8%が示唆されています）。",
        contentFee: "個別購読変更した場合の「追加コンテンツ料金」",
        contentFeeDescr: "個別購読への変更時に出版社が課す追加コンテンツ料金です。（文献では購読の5.7%が示唆されています。）",
        illTransactionCost: "ILL処理コスト",
        illTransactionCostDescr: "貴機関のILLリクエスト1件あたりのコスト（文献では平均$17となっております）。",
        illRequestRate: "ILLリクエスト率",
        illRequestRateDescr: "フルテキスト閲覧ができない場合にILLリクエストへ至る割合です。広範な文献レビューにより、平均5%となっております。",
        includeBronzeOA: "ブロンズOAを含める",
        includeBronzeOADescr: "ブロンズOAを充足率に含めます。",
        permitNonPeerReviewed: "査読前バージョンを許可",
        permitNonPeerReviewedDescr: "グリーンOAにおいて、投稿バージョンを充足率に含めます。",
        includeResearchGate: "ResearchGateコンテンツを含める",
        includeResearchGateDescr: "ResearchGateおよびその他のアカデミックSNSを充足率に含めます。",
        authorshipWeight: "機関著者ウェイト",
        authorshipWeightDescr: "貴機関の著者が該当ジャーナルに採択された実績に応じた、利用量に対しての調整係数です。",
        citationWeight: "機関引用ウェイト",
        citationWeightDescr: "貴機関からの該当ジャーナルへの引用数に応じた、利用量に対しての調整係数です。",
        couldTakeAWhile: "しばらくお待ちください...",
        recalcWarning: "このパラメータの変更により予測が再計算されます。最大60分かかる場合があり、その間シナリオの表示・編集はできません。",
        recalcEmailNotice: "完了したら{email}にメールをお送りします（迷惑メールフォルダもご確認ください）。",
        saveAndWait: "保存して待機",
        settingUpdated: "設定が更新されました",
        settingsReset: "設定がリセットされました",
        confirmReset: "リセットの確認",
        confirmResetText: "このシナリオのすべての設定をデフォルト値にリセットしてもよろしいですか？この操作は元に戻せませんので、事前にバックアップコピーを保存することをお勧めします。",
        yesResetAll: "はい、すべてリセットします",
    },

    columns: {
        publisher: "出版社",
        publisherShort: "出版社（略称）",
        costPerUse: "利用単価",
        rankByCPU: "利用単価順位",
        cost: "コスト",
        usage: "利用量",
        instantUsagePercent: "即時利用率",
        freeInstantUsagePercent: "無料即時利用率",
        subscriptionCost: "購読コスト",
        illCost: "ILLコスト",
        subscriptionMinusIll: "購読マイナスILLコスト",
        downloads: "ダウンロード数",
        citations: "被引用論文数",
        authorships: "著者論文数",
        pta: "PTA（終了後アクセス権）",
        baselineAccess: "ベースラインアクセス",
        sortAsc: "昇順",
        sortDesc: "降順",
        addRemoveColumns: "列の追加/削除",
        noJournalsMatched: "検索に一致するジャーナルがありません。",
    },

    columnGroups: {
        metadata: "メタデータ",
        costEffectiveness: "費用対効果",
        costs: "コスト",
        openAccess: "オープンアクセス",
        fulfillment: "充足率",
        impact: "インパクト",
    },

    segments: {
        unknown: "不明",
        accessUnknown: "アクセス不明",
        ill: "ILL",
        interLibraryLoan: "相互貸借",
        subscription: "購読",
        titleByTitle: "個別購読",
        oa: "オープンアクセス",
        backfile: "PTA",
        postTermination: "終了後アクセス権（バックファイル）",
        savings: "節約",
        costSavings: "コスト節約",
        requested: "リクエスト済み",
        requestedByMembers: "コンソーシアムメンバーによるリクエスト",
        titleByTitleCost: "個別購読コスト",
        requestedCost: "リクエスト購読コスト",
    },

    segmentDesc: {
        costSavings: "今後5年間の年間節約額です（現在のモデルに基づく）。",
        costSubr: "今後5年間の購読支出です（現在のモデルに基づく）。",
        costRequested: "今後5年間の<em>リクエストされた</em>購読支出です（現在のモデルに基づく）。",
        costIll: "今後5年間のILL支出です（現在のモデルに基づく）。",
        usageTurnaway: "利用量のうち、OAまたは図書館で充足できず、ILLリクエストも発生しない割合です。現在の研究では、このような場合、利用者は同僚にコピーをメールで依頼したり、Sci-Hubを利用したり、代替論文を探したりすることが示唆されていますが、利用者行動の詳細はまだ十分に解明されていません。",
        usageIll: "利用量のうち、無料ソースや購読では充足できず、ILLリクエストに至る割合です。",
        usageSubr: "利用量のうち、無料ソースでは充足できないが、個別購読で充足できる割合です。",
        usageRequested: "利用量のうち、無料ソースでは充足できないが、<em>リクエストされた</em>個別購読で充足可能な割合です。",
        usageBackfile: "利用量のうち、オープンアクセスでは充足できないが、PTA権により充足できる割合です。",
        usageOa: "利用量のうち、オンラインのオープンアクセスで充足できる割合です。",
    },

    publisher: {
        setup: "セットアップ",
        scenarios: "予測シナリオ",
        editDetails: "詳細を編集",
        apc: "APC",
        loadingPackage: "パッケージを読み込み中",
        package: "パッケージ",
        noDescription: "説明なし",
        requiredData: "必須データ",
        recommendedData: "推奨データ",
        optionalData: "任意データ",
        diagnosticData: "診断データ",
        counter: "COUNTER",
        pricelist: "ジャーナル価格リスト",
        bigDealCosts: "ビッグディールコスト",
        ptaAccess: "PTA（終了後アクセス権）",
        journalFilter: "ジャーナルフィルター",
        excludedTitles: "除外タイトル",
        newPackage: "新規パッケージ",
        addPackage: "購読パッケージを追加",
        packageName: "パッケージ表示名",
        description: "説明",
        packageCreated: "パッケージを作成しました。",
        packageDeleted: "パッケージを削除しました。",
        packageRenamed: "パッケージ名を変更しました。",
        descriptionEdited: "説明を編集しました。",
        editPackageName: "パッケージ名を編集",
        editDescription: "説明を編集",
        deletePackage: "パッケージを削除",
        deletePackageConfirm: "このパッケージを削除してもよろしいですか？",
        yesDeleteIt: "はい、削除します",
        renamePackage: "パッケージ名を変更",
        newPackageName: "新しいパッケージ名",
        consortialFeederAlert: "これはコンソーシアムフィーダーパッケージです。コンソーシアムの中央Unsubダッシュボードにデータを提供するためのものです。",
        consortialProposalAlert: "これはコンソーシアム提案パッケージです。コンソーシアムが提案するキャンセルシナリオのリストが含まれています。",
        makeCopy: "コピーを作成",
        rename: "名前を変更",
    },

    publisherFile: {
        processing: "{name}を処理中...",
        processingDescription: "最大10分かかる場合があります。",
        uploadedWithError: "{name}がアップロードされましたが、エラーがあります！",
        errorDescription: "ファイルに問題があり、使用できません。削除してエラーを修正し、再度アップロードしてください。",
        uploaded: "{name}がアップロードされました。",
        extractedRows: "{count}行の有効なデータを抽出しました。このデータはこのパッケージに属するシナリオで使用されています。",
        selectFile: "{name}ファイルを選択",
        uploadFailed: "アップロードに失敗しました",
        fileUploaded: "ファイルがアップロードされました。",
        fileDeleted: "ファイルが削除されました。",
        deleteFile: "ファイルを削除",
        deleteFileConfirm: "このファイルを削除してもよろしいですか？",
        downloaded: "{name}をダウンロードしました。",
        unrecognizedFileExtension: "認識できないファイル拡張子",
        fileUploadFailed: "ファイルのアップロードに失敗しました。",
        demoCannotDelete: "デモアカウントではデータを削除できません。",
    },

    institution: {
        demoRestricted: "これはデモ機関です。一部の機能が制限されています。",
        purchaseFullAccount: "フルアカウントを購入",
        packages: "パッケージ",
        users: "ユーザー",
        rorIds: "ROR ID",
        apcReport: "APCレポート",
        consortialFeeders: "コンソーシアムフィーダー",
        consortialProposals: "コンソーシアム提案",
        newGroupMember: "新しいグループメンバー",
        addGroupMember: "グループメンバーを追加",
        email: "メールアドレス",
        role: "役割",
        welcomeEmailNote: "このユーザーを作成すると、自動的にウェルカムメールが送信されます。",
        createGroupMember: "グループメンバーを作成",
        userCreated: "新しいユーザーが作成され、ウェルカムメールが送信されました。",
        userRoleUpdated: "ユーザーの役割が更新されました。",
        consortia: "コンソーシアム",
        demoCannotAddPackages: "デモプロファイルではパッケージを追加できません。",
        consortialFeederDataSource: "これらはコンソーシアムの中央Unsubダッシュボードへのデータソースとしてのみ機能します。",
        jiscNotRequesting: "Jiscは現在Unsub経由でシナリオのフィードバックをリクエストしていません",
        you: "（あなた）",
        selectRole: "役割を選択",
        consortium: "コンソーシアム",
        institutionLabel: "機関",
    },

    login: {
        notSupportedMobile: "モバイル非対応",
        notSupportedMobileDesc: "申し訳ありませんが、現在モバイルデバイスでのログインはサポートされていません。デスクトップまたはラップトップからログインしてください。",
        signIn: "サインイン",
        step1: "ステップ 1",
        step2of2: "ステップ 2/2",
        emailLabel: "メールアドレス",
        passwordLabel: "パスワード",
        forgotPassword: "パスワードをお忘れですか？",
        logIn: "ログイン",
        accountNotFound: "アカウントが見つかりませんでした。",
        passwordIncorrect: "パスワードが正しくありません",
    },

    user: {
        myAccount: "マイアカウント",
        demoRestricted: "これはデモアカウントです。一部の機能が制限されています。",
        yourAccount: "アカウント設定",
        yourName: "名前",
        yourEmail: "メールアドレス",
        yourPassword: "パスワード",
        noneSet: "未設定",
        emailTaken: "このメールアドレスは既に使用されています。",
        updated: "{field}を更新しました",
        userLabel: "ユーザー",
        settings: "設定",
    },

    recoverPassword: {
        title: "パスワードの回復",
        description: "ご安心ください。パスワードをリセットするためのリンクをメールでお送りします。",
        accountEmail: "アカウントのメールアドレス",
        sendLink: "回復リンクをメールで送信",
        emailSent: "回復メールを送信しました",
        emailSentDesc: "パスワードリセット用のリンクを含むメールを送信しました。1〜2分で届きます（迷惑メールフォルダもご確認ください）。",
    },

    resetPassword: {
        changePassword: "パスワードを変更",
        newPassword: "新しいパスワード",
        changeButton: "パスワードを変更",
        success: "パスワードが変更されました！",
        successDesc: "パスワードが正常に更新されました。ログインできます。",
        error: "パスワード更新エラー",
        errorDesc: "パスワードを更新できませんでした。",
        requestAnother: "別のリセットメールをリクエスト",
    },

    scenarioEdit: {
        copyScenario: "このシナリオをコピー",
        nameForNewScenario: "新しいシナリオの名前:",
        createNewScenario: "新規シナリオを作成",
        newScenarioWarning: "新しいシナリオはすぐに作成されますが、完全にプロビジョニングされて使用可能になるまで最大1時間かかります。",
        newScenarioEmail: "シナリオが使用可能になったら{email}にメールをお送りします（迷惑メールフォルダもご確認ください）。",
        copyInstead: "待ちたくない場合は、既存のシナリオをコピーすることもできます...数秒で完了します。",
        renameScenario: "このシナリオの名前を変更",
        newName: "新しい名前:",
        deleteScenario: "このシナリオを削除",
        deleteScenarioConfirm: "このシナリオを削除してもよろしいですか？この操作は元に戻せません。",
        openScenario: "シナリオを開く",
        scenarioLoading: "シナリオを読み込み中...",
        scenarioCopied: "シナリオをコピーしました",
        scenarioRenamed: "シナリオの名前を変更しました",
        scenarioDeleted: "シナリオを削除しました",
    },

    scenarioExport: {
        exportDescription: "このシナリオのすべてのデータをCSVファイルとしてエクスポートできます。<a href=\"https://docs.unsub.org/reference/data-export\" target=\"_blank\">ドキュメントはこちら</a>をご覧ください。",
        exportExtender: "エクスポートしたデータをさらに分析・可視化するには、アイオワ州立大学の図書館員Eric Scharesが作成した無料のサードパーティツール「<a href=\"https://unsubextender.lib.iastate.edu/\" target=\"_blank\">Unsub Extender（外貨・英語）</a>」または、日本語版「<a href=\"https://unsub-extender-jpn.ijapan.info/\" target=\"_blank\">Unsub Extender</a>」をご利用ください。",
        memberSubRequests: "メンバー購読リクエスト（ベータ版）",
        memberSubRequestsDesc: "メンバー機関がこのシナリオに含めるようリクエストした購読のリストを取得します。",
        downloadViaEmail: "ダウンロード（メール経由）",
        youllGetEmail: "まもなくメールが届きます",
    },

    scenarioMenu: {
        table: "テーブル",
        histogram: "ヒストグラム",
        export: "エクスポート",
        downloadSpreadsheet: "スプレッドシートとしてダウンロード",
        yourApiKey: "APIキー",
        publicSummary: "公開サマリーページ",
        apiKeyDescription: "パブリックAPIにはキーは不要ですが、このユニークキーによりAPI経由でアカウントデータにもアクセスできます:",
        publicSummaryDescription: "このページを有効にすると、公開URLでこのシナリオを共有できます。管理者や教員との予測共有に便利です。",
        enablePublicSummary: "公開サマリーページを有効にする",
        underConstruction: "この機能はまだ構築中です。",
        knowledgeBase: "ナレッジベース",
        contactUs: "お問い合わせ",
        view: "表示",
        showBarGraphs: "棒グラフを表示",
        costsByType: "タイプ別コスト",
        usageByType: "タイプ別利用量",
        subscriptions: "購読",
        unsubscribeAll: "すべて購読解除",
        subscribeAll: "すべて購読",
        unsubscribeToAll: "{count}件のジャーナルすべての購読を解除",
        subscribeToAll: "{count}件のジャーナルすべてを購読",
        parameters: "パラメータ",
        resetAll: "すべてリセット",
    },

    scenarioInstitutions: {
        institutions: "機関",
        searchInstitutions: "機関を検索",
        selectAtLeastOne: "少なくとも1つの機関を選択してください。",
        institutionsUpdated: "機関が更新されました。",
        yourMemberInstitutions: "メンバー機関",
        institutionsSelected: "件の機関を選択中",
        mustSelectOne: "少なくとも1つの機関を選択してください",
        memberInstitutions: "メンバー機関",
        showingDataFrom: "データ表示：",
    },

    scenarioPushPull: {
        pushPull: "送受信",
        sendScenario: "メンバーにシナリオを送信",
        sendDescription: "件のメンバー機関を選択しました。このシナリオのコピーを送信します。",
        scenarioShared: "シナリオが共有され、通知が送信されました。",
        searchByNameOrTags: "名前またはタグで検索",
        included: "含む",
        institutionName: "機関名",
        sent: "送信済み",
        lastChanged: "最終変更",
        lastReturned: "最終返却",
        sendToConsortium: "コンソーシアムに送信",
    },

    overview: {
        cpu: "利用単価",
        subscribed: "購読中",
        notSubscribed: "未購読",
        subscribedJournals: "購読ジャーナル",
        requestedJournals: "リクエスト済みジャーナル",
        overwriteCustom: "カスタム購読を上書きしますか？",
        overwriteCustomDesc: "カスタムのタイトル別購読が上書きされ、利用単価が最も低い{count}件のジャーナルが自動的に購読されます。よろしいですか？",
        yepOverwrite: "はい、上書きします。",
        yearly: "年間",
        projected: "予測",
        journalsArrangedByCPU: "件のジャーナル（利用単価順）",
        additionalJournalsCPU: "件の追加ジャーナル（利用単価 >",
        additionalJournalsNoUsage: "件の追加ジャーナル（ペイウォール利用なし）",
        ofBigDeal: "ビッグディール比",
        fulfilledInstantly: "即時充足",
        uses: "利用",
    },

    overviewDetail: {
        costParagraph1: "このシナリオでは、ビッグディールを解約し、{subscribedCount}件のジャーナルの{subscriptions}を行います（残りの{remainingCount}件のジャーナルの{illCosts}が増加します）。",
        costParagraph2: "予測モデルとカスタム設定に基づいてコストを推定します。このシナリオでは年間{cost}のコストが見込まれ、これはビッグディール支出の{percent}に相当します。",
        subscriptions: "個別購読",
        illCosts: "ILLコスト",
        usageParagraph1: "COUNTERデータと予測モデルに基づき、このビッグディールの{count}件のジャーナルは今後5年間で{usage}を発生させると予測されます。",
        usageParagraph2: "このうち{percent}のリクエストは、{freeSources}（オープンアクセスおよび終了後アクセス権）または{subscriptionLinks}により、利用者に不便をかけることなく即時に充足できます。",
        usageRequests: "コンテンツリクエスト（利用イベント）",
        freeSources: "無料ソース",
        titleByTitleSubscriptions: "個別購読",
    },

    singleJournal: {
        journal: "ジャーナル",
        overview: "概要",
        institutions: "機関",
        timelines: "タイムライン",
        journalMetadata: "ジャーナルメタデータ",
        publisherLabel: "出版社",
        subject: "主題",
        issn: "ISSN",
        societyJournal: "学会ジャーナル",
        delayedOA: "ディレイドOA",
        oaEmbargoLength: "OAエンバーゴ期間",
        months: "ヶ月",
        ptaRights: "PTA（終了後アクセス権）",
        annualUsage: "年間利用量",
        weightedOverallUses: "加重全体利用量",
        paywalledUses: "ペイウォール利用",
        annualCost: "年間コスト",
        baseSubscriptionCost: "基本購読コスト",
        illCostLabel: "ILLコスト",
        netSubscriptionCost: "純購読コスト",
        costPerUseLabel: "利用単価",
        loadingJournalDetail: "ジャーナル詳細を読み込み中",
        loadingInstitutionDetail: "機関詳細を読み込み中",
        subscribe: "購読する",
        unsubscribe: "購読解除",
        request: "リクエスト",
        unrequest: "リクエスト取消",
        journalRequested: "ジャーナルをリクエストしました",
        journalUnrequested: "ジャーナルのリクエストを取り消しました",
        fulfillment: "充足率",
        impact: "インパクト",
        subscriptionCostLabel: "購読コスト",
        apiResponse: "APIレスポンス",
        unsubscribed: "未購読",
        notes: "注記:",
        downloadsWeight: "ダウンロード <br> @ 1x",
        citationsWeight: "被引用 <br> @ {weight}x",
        authorshipsWeight: "著者論文 <br> @ {weight}x",
        oaWithPercent: "オープンアクセス ({percent}%)",
        backfileWithPercent: "バックファイル ({percent}%)",
    },

    journalDetail: {
        type: "タイプ",
        usageProjectedAnnual: "利用量（年間予測）",
        usagePercent: "利用量（%）",
        oaType: "OAタイプ",
        percentOfAllUsage: "全利用量に占める割合",
        rawProjectedAnnual: "実数（年間予測）",
        weight: "ウェイト",
        usageContribution: "利用量への寄与",
        costType: "コストタイプ",
        costProjectedAnnual: "コスト（年間予測）",
        costTypePerPaidUse: "有料利用あたりコストタイプ",
        researchGateEtc: "ResearchGate等",
        green: "グリーン",
        hybrid: "ハイブリッド",
        bronze: "ブロンズ",
        total: "*合計*",
        downloadsLabel: "ダウンロード",
        citationsLabel: "このジャーナルの論文への被引用",
        authorshipsLabel: "このジャーナルの著者論文",
        yourScenarioCost: "*このシナリオのコスト*",
        subscriptionByYear: "年別購読コスト",
        illByYear: "年別ILLコスト",
        subscriptionMinusIllByYear: "年別購読マイナスILLコスト",
        noPaidUsage: "ペイウォール利用なし",
        ptaNote: "PTA（終了後アクセス権）はOAとして利用できないコンテンツのみが対象です。",
        greenNote: "グリーンOAはハイブリッドまたはブロンズとして利用できないコンテンツのみが対象です。",
        delayedOANote: "このジャーナルはエンバーゴ期間{months}ヶ月の後、バックコンテンツを公開しています。",
        currentlySubscribed: "このジャーナルは現在購読中です。",
        currentlyNotSubscribed: "このジャーナルは現在購読していません。",
    },

    apc: {
        articlePublicationCosts: "昨年のAPC（論文掲載料）",
        totalApcExpenditure: "APC総支出（ゴールド・ハイブリッド）",
        apcLoading: "APCデータを読み込み中...",
        apcDescription: "貴機関の著者は昨年、推定{cost}のAPC（論文掲載料）を支払いました。この金額にはゴールドおよびハイブリッドOAジャーナルに支払われたAPCが含まれます。OpenAlexが貴機関を論文の責任著者機関として特定した場合、APC全額を帰属させます。その情報がない場合は、各著者が同等の確率で責任著者であると仮定した推定値を使用します。",
        journalsPaidByAuthors: "貴機関の著者が支払った{count}件のジャーナル",
        searchJournals: "ジャーナルを検索",
    },

    dataFiles: {
        counter: "COUNTER",
        counterType: "COUNTERデータ",
        ptaDateRanges: "PTA期間",
        ptaType: "終了後アクセス権の期間",
        filterTitles: "タイトルフィルター",
        filterType: "パッケージに含めるタイトル",
        pricelist: "個別価格リスト",
        pricelistType: "個別購読価格",
    },

    app: {
        notSupportedYet: "申し訳ありませんが、その機能はまだサポートされていません。詳しくはsupport@openalex.orgにお問い合わせください。",
        cantChangeInEditMode: "編集モード中はコンフィグを変更できません",
    },

    setup: {
        setupPrefix: "設定:",
        requiredData: "必須データ",
        recommendedData: "推奨データ",
        optionalData: "オプションデータ",
        diagnosticData: "診断データ",
        fullyLoaded: "<strong>読み込み完了: </strong> このデータは現在すべての予測シナリオで使用されています。",
        missingData: "<strong>データ不足: </strong> このデータは必須です。",
        missingPricesNone: "価格情報が欠落しているジャーナルはありません。",
        missingPricesRequired: "<strong>必須データ不足: </strong> ",
        missingPricesStill: "<strong>データ不足: </strong> カスタム価格リストをアップロード済みですが、",
        missingPricesSuffix: "件のジャーナルに価格情報がありません。これらはすべての予測から除外されています。修正するには、以下から新しいカスタムジャーナル価格リストをアップロードし、不足しているタイトルの価格を入力してください。",
        viewMissingTitles: "欠落タイトルを表示",
        journalsDownloaded: "ジャーナルをダウンロードしました。",
        consortiumSetupNote: "コンソーシアムダッシュボードの設定は、メール又は会員機関ダッシュボードからのデータインポートにより舞台裏で行われます。設定に関するご質問は、以下までご連絡ください：",
        counterVersion: "COUNTERバージョン",
        counterVersionDescNoVersion: "使用するCOUNTERレポートの種類を設定します。より正確な予測を生成するCOUNTER 5レポートの使用を推奨します。",
        counterVersionDescV4: "使用中のCOUNTERレポートのバージョンを設定します。編集するには、アップロード済みのCOUNTER 4 JR1レポートを先に削除してください。",
        counterVersionDescV5: "使用中のCOUNTERレポートのバージョンを設定します。編集するには、アップロード済みの3つのCOUNTER 5レポートを先に削除してください。",
        counterReportFiles: "COUNTERレポートファイル",
        counter5Instructions: "COUNTER 5では、<strong>TR_J2、TR_J3、</strong>および<strong>TR_J4</strong>の3つのレポートをアップロードする必要があります。COUNTER 5.0と5.1の両方のフォーマットに対応しています。Unsubではダッシュボードを作成するために3つのファイルすべてが必要です。各ファイルには3行以上のデータ（ヘッダーを除く）が必要です。<strong>TR_J2</strong>ファイルを取得できない場合、またはヘッダー行以外にデータがない場合は、<a href=\"https://unsub-public.s3.amazonaws.com/TR_J2.csv\">このダミー<strong>TR_J2</strong>ファイル</a>をダウンロードしてご利用ください。ダッシュボードへの影響はありません。",
        counter4Instructions: "COUNTER 4では、1つのファイルをアップロードする必要があります：",
        journalPricelist: "ジャーナル価格リスト",
        pricelistInstructions: "ジャーナルごとのタイトル別価格を含むスプレッドシートをアップロードしてください。スプレッドシートには<strong>ISSN</strong>と<strong>Price</strong>の2列が必要です。対応フォーマット：",
        pricelistFormats: "および",
        ptaFile: "PTAファイル",
        ptaInstructions: "PTA（購読終了後のアクセス権）の日付を、ジャーナルごとに1行のスプレッドシートとしてアップロードしてください。スプレッドシートには<strong>ISSN</strong>、<strong>開始日</strong>、<strong>終了日</strong>の3列が必要です。PTAが継続中のジャーナルについては、<strong>終了日</strong>を空白のままにしてください。",
        ptaFormats: "対応フォーマット：",
        filterFile: "スプレッドシートまたはKBARTファイル",
        filterInstructions: "以下のいずれかの形式でファイルをアップロードしてください：",
        filterOption1: "1ジャーナルにつき1行、<a target=\"_blank\" href=\"https://en.wikipedia.org/wiki/International_Standard_Serial_Number\">ISSN</a>だけを記載してください。",
        filterOption2: "{kbartLink}",
        filterFormats: "両方の対応ファイル形式：",
        excludedDescription: "COUNTERレポート内の一部のジャーナルは、<a href=\"https://docs.unsub-jpn.ijapan.info/#/troubleshooting/missing-title\" target=\"_blank\">さまざまな理由</a>によりシナリオ予測から除外されています。ここでは、除外されたタイトルとその理由を含むCSVレポートをダウンロードできます。詳細は<a href=\"https://docs.unsub-jpn.ijapan.info/#/how-to-guides/excluded-titles-report\" target=\"_blank\">ドキュメント</a>をご覧ください。",
        excludedTitlesButton: "除外タイトル",
        fiveYearCostDescription: "これは、ビッグディールを更新した場合の今後5年間の推定年間パッケージコストです。基本年間コストから自動計算されます：年間コスト増加率による5年間の値上げを計算し、年間平均を算出します。この数値は、さまざまな解約シナリオでの年間節約コストの算出に使用されます。",
        ptaMissingWarning: "<strong>データ不足: </strong> 予測は現在、すべてのタイトルに対して<em>PTAの権利がゼロ</em>であると仮定しています。これはおそらく正しくないため、予測は正確ではありません。",
        filterOptionalMsg: "<strong>オプションデータ: </strong> ISSNのスプレッドシートまたはKBARTファイルを提供することで、このパッケージ内のすべてのシナリオを特定のタイトルのみにフィルタリングできます。",
        excludedDiagnosticMsg: "<strong>このパッケージから除外されたタイトルのレポートをダウンロードします。</strong>",
        tabCounter: "COUNTER",
        tabPricelist: "価格リスト",
        tabPricelistLong: "ジャーナル価格リスト",
        tabCurrency: "通貨",
        tabBigDealCosts: "ビッグディールコスト",
        tabPta: "PTA",
        tabPtaLong: "PTA（購読終了後のアクセス権）",
        tabFilter: "フィルター",
        tabFilterLong: "ジャーナルフィルター",
        tabExcludedTitles: "除外タイトル",
        priceCurrencyLabel: "価格リストの通貨",
        priceCurrencyDescription: "アップロードした価格リストの通貨を選択してください。パッケージ通貨と異なる場合、TTSレートで自動換算されます。",
        priceCurrencySaved: "価格リストの通貨を保存しました。",
    },

    homepage: {
        tagline: "ビッグディールを分析する、より良い方法。",
        description: "Unsubダッシュボードは、契約の価値を再評価し、解約オプションを理解するのに役立ちます。",
        watchVideo: "動画を見る",
        readCaseStudies: "導入事例を読む",
        usedIn: "大小{count}以上の図書館で利用されています：",
        usedInLibraries: "500",
        wantToLearnMore: "もっと知りたいですか？",
        watchGuidedTour: "動画でガイドツアーをご覧ください。",
        guidedTourLabel: "ガイドツアーを見る：",
        sellingPoint1Header: "パッケージ購読の全体像を把握",
        sellingPoint1Text: "オープンアクセスや購読終了後アクセス権（PTA）での利用分を考慮し、さらにお客様機関に所属している研究者の論文の引用・投稿数も加味してシミュレーションすることができます。",
        sellingPoint2Header: "購読の選択肢を探索",
        sellingPoint2Text: "タイトル購読を行った際のシナリオを作成し、今後5年間の図書館が負担するコストとアクセス充足率を予測します。",
        sellingPoint3Header: "取捨選択時間の節約",
        sellingPoint3Text: "複雑なスプレッドシートは不要です。COUNTERレポートとPTA（ジャーナル購読終了後のアクセス権）のデータをアップロードするだけで、Unsubで将来の予測を立てる準備は完了です。",
        usersLoveUnsub: "ユーザーに愛されるUnsub",
        testimonialIntro: "私たちの言葉だけでは物足りないですか？いただいたフィードバックの一部をご紹介します：",
    },

    ror: {
        description: "ROR IDは研究機関の永続的識別子です（論文のDOIのようなもの）。機関の引用数および著者数は、機関のROR IDに基づいて集計されます。",
        demoRorId: "（デモ用ROR ID）",
        viewOnRor: "www.ror.org でレコードを表示",
    },

    apc: {
        description: "機関のゴールドおよびハイブリッドオープンアクセス論文に対するAPC（論文処理費用）支出の推定レポートをダウンロードできます。OpenAlexが論文の責任著者所属機関としてお客様の機関を特定した場合、APCの全額をお客様に帰属させます。責任著者所属機関の情報が利用できない場合は、論文の各著者が責任著者である可能性が等しいと仮定した推定値を使用します。",
        dataSource: "論文はOpenAlexから取得され、OpenAlexの論文別APCデータを使用して個別に価格が設定されています。現在、幅広い出版社をカバーしています。",
        readDocs: "詳細は{link}をご覧ください。",
        docsLinkText: "APCレポートのドキュメント",
    },

    warnings: {
        missingPerpetualAccess: "PTA不足",
        missingPrices: "価格情報不足リスト",
        missingCounterData: "COUNTER不足",
        missingBigDealCosts: "ビッグディールコスト不足",
        filteringTitles: "ジャーナルホワイトリスト",
    },

    language: {
        label: "言語",
        en: "English",
        ja: "日本語",
    },
}
